@if (labelList) {
  @if (labelList.length > 0) {
    <mat-select
      [panelClass]="'label-select-panel'"
      [(ngModel)]="selectedLabel"
      (ngModelChange)="setStatementLabel($event)"
      [panelWidth]="'150px'"
    >
      <mat-option>NONE</mat-option>
      @for (label of labelList; track label) {
        <mat-option [value]="label">
          {{ label.name }}
        </mat-option>
      }
    </mat-select>
  }
}
